// client/src/coms/components/comslayout_parts/layoutUtils.js
export function clamp(n, min, max) {
  if (n < min) return min;
  if (n > max) return max;
  return n;
}

export function clamp01(n) {
  if (n < 0) return 0;
  if (n > 1) return 1;
  return n;
}

export function isComsAdsEnabled() {
  try {
    if (typeof window === 'undefined') return true;
    if (window.localStorage.getItem('__pa_disable_coms_ads') === '1') return false;
    return true;
  } catch {
    return true;
  }
}

export function safePickServer(servers, serverId) {
  if (!Array.isArray(servers) || !servers.length) return null;
  const sid = serverId != null ? String(serverId) : '';
  if (!sid) return null;
  const s = servers.find((x) => String(x.id) === sid);
  return s || null;
}

export const COMS_SIDEBAR_MIN_WIDTH = 200;
export const COMS_SIDEBAR_DEFAULT_WIDTH = 340;
export const COMS_SIDEBAR_MAX_WIDTH = 520;

export function getComsSidebarWidth() {
  try {
    if (typeof window === 'undefined') return COMS_SIDEBAR_DEFAULT_WIDTH;

    const raw = window.localStorage.getItem('__pa_coms_sidebar_width');
    if (raw == null || String(raw).trim() === '') return COMS_SIDEBAR_DEFAULT_WIDTH;

    const v = Number(raw);
    if (!Number.isFinite(v)) return COMS_SIDEBAR_DEFAULT_WIDTH;

    return clamp(Math.round(v), COMS_SIDEBAR_MIN_WIDTH, COMS_SIDEBAR_MAX_WIDTH);
  } catch {
    return COMS_SIDEBAR_DEFAULT_WIDTH;
  }
}

export function setComsSidebarWidthPersist(v) {
  try {
    if (typeof window === 'undefined') return;
    const next = clamp(
      Math.round(Number(v) || COMS_SIDEBAR_DEFAULT_WIDTH),
      COMS_SIDEBAR_MIN_WIDTH,
      COMS_SIDEBAR_MAX_WIDTH
    );
    window.localStorage.setItem('__pa_coms_sidebar_width', String(next));
  } catch {}
}

export function resetComsSidebarWidthPersist() {
  try {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem('__pa_coms_sidebar_width');
  } catch {}
}

// Phone layout: narrow windows, and landscape phones (short and touch-driven) such as 915 x 412.
export const MOBILE_QUERY = '(max-width: 900px), (max-height: 500px) and (pointer: coarse)';

export function isMobileViewport() {
  try {
    if (typeof window === 'undefined') return false;
    if (!window.matchMedia) return false;
    return !!window.matchMedia(MOBILE_QUERY).matches;
  } catch {
    return false;
  }
}

export function normalizeDbIdKey(v) {
  const m = String(v || '').match(/(\d+)$/);
  return m && m[1] ? m[1] : '';
}

export function toInt(v, fallback = 0) {
  const n = Number(v);
  return Number.isFinite(n) ? Math.floor(n) : fallback;
}

export function makeCanonicalVoiceRoomName(serverDbId, voiceChannelDbId) {
  const sdb = toInt(serverDbId, 0);
  const cdb = toInt(voiceChannelDbId, 0);
  if (!sdb || !cdb) return '';
  return `coms_${sdb}_${cdb}`;
}

export function buildVoiceRoomsForServer(server) {
  const s = server && typeof server === 'object' ? server : null;
  const serverDbId = s && s.db_id != null ? toInt(s.db_id, 0) : 0;
  if (!serverDbId) return [];

  const channels = Array.isArray(s.channels) ? s.channels : [];
  const voice = channels.filter((c) => c && c.kind === 'voice' && c.db_id != null);

  const out = [];
  for (const ch of voice) {
    const cdb = toInt(ch.db_id, 0);
    if (!cdb) continue;
    const room = makeCanonicalVoiceRoomName(serverDbId, cdb);
    if (!room) continue;
    out.push({ channelDbId: String(cdb), room });
  }
  return out;
}

export function buildNameByIdFromPresence(voicePresenceByChannel) {
  const out = {};
  const byCh = voicePresenceByChannel && typeof voicePresenceByChannel === 'object' ? voicePresenceByChannel : {};
  for (const chId of Object.keys(byCh)) {
    const list = Array.isArray(byCh[chId]) ? byCh[chId] : [];
    for (const p of list) {
      if (!p) continue;
      const rawId = p.userId != null ? String(p.userId) : p.user_id != null ? String(p.user_id) : '';
      const m = String(rawId || '').match(/(\d+)$/);
      const uid = m && m[1] ? Number(m[1]) : NaN;
      if (!Number.isFinite(uid)) continue;
      const name = String(p.name || '').trim();
      if (name) out[uid] = name;
    }
  }
  return out;
}

export function pickServerMemberDisplayName(servers, serverId, uid) {
  try {
    const sid = serverId != null ? String(serverId) : '';
    if (!sid) return '';
    const nuid = Number(uid);
    if (!Number.isFinite(nuid)) return '';

    const list = Array.isArray(servers) ? servers : [];
    const s = list.find((x) => x && String(x.id) === sid);
    if (!s) return '';

    const members = Array.isArray(s.members) ? s.members : [];
    const m = members.find((mm) => {
      if (!mm) return false;
      const id = mm.user_id != null ? mm.user_id : mm.id != null ? mm.id : mm.userId != null ? mm.userId : null;
      return id != null && Number(id) === nuid;
    });
    if (!m) return '';

    const dn = m.display_name != null ? String(m.display_name || '').trim() : '';
    if (dn) return dn;

    const un = m.username != null ? String(m.username || '').trim() : '';
    if (un) return un;

    const nm = m.name != null ? String(m.name || '').trim() : '';
    if (nm) return nm;

    return '';
  } catch {
    return '';
  }
}